export type InterviewWebSocketErrorKind = 'session_recovery' | 'interview_finished' | 'other';

export interface InterviewConnectPayloadInput {
  sessionId: string;
  interviewId: number | null;
  avatarId: number;
  avatarType: string;
  dubbingVideo?: string;
  gender?: string;
  age?: number;
  instructionId?: string;
  userAgent?: string;
}

export function classifyInterviewWebSocketError(
  code: unknown,
  message: unknown,
): InterviewWebSocketErrorKind {
  const codeText = typeof code === 'string' ? code : '';
  const messageText = typeof message === 'string' ? message : '';

  if (
    codeText === 'SESSION_NOT_FOUND'
    || codeText === 'STT_SESSION_NOT_FOUND'
    || (/^RECOGNITION_(START|STOP)_ERROR$/.test(codeText) && /session/i.test(messageText))
  ) {
    return 'session_recovery';
  }
  if (codeText === 'INTERVIEW_FINISHING') return 'interview_finished';
  return 'other';
}

export function createInterviewConnectPayload(input: InterviewConnectPayloadInput) {
  const dubbingVideoFile = input.dubbingVideo?.replace(/^\/videos\//, '');
  return {
    sessionId: input.sessionId,
    interviewId: input.interviewId,
    avatarId: input.avatarId.toString(),
    avatarType: input.avatarType,
    clientType: 'public',
    dubbingVideoFile,
    gender: input.gender,
    ageRange: resolveAgeRange(input.age),
    userAgent: input.userAgent,
    ...(input.instructionId ? { instructionId: Number(input.instructionId) } : {}),
  };
}

export function resolveAgeRange(age: number | undefined): '20-34' | '35-49' | '50+' {
  if (age === undefined || age === null || age <= 34) return '20-34';
  if (age <= 49) return '35-49';
  return '50+';
}
